"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.allergyTypeMessages = exports.AllergyType = void 0;
const schema_1 = require("../../../../schema");
var AllergyType;
(function (AllergyType) {
    AllergyType["DRUG"] = "DRUG";
    AllergyType["FOOD"] = "FOOD";
    AllergyType["CONTRAST_AGENT"] = "CONTRAST_AGENT";
})(AllergyType || (exports.AllergyType = AllergyType = {}));
exports.allergyTypeMessages = {
    [AllergyType.DRUG]: {
        id: "ltx.phaseI.medicalHistory.allergiesAndSensitivities.allergyType.DRUG",
        defaultMessage: "Gyógyszer"
    },
    [AllergyType.FOOD]: {
        id: "ltx.phaseI.medicalHistory.allergiesAndSensitivities.allergyType.FOOD",
        defaultMessage: "Étel"
    },
    [AllergyType.CONTRAST_AGENT]: {
        id: "ltx.phaseI.medicalHistory.allergiesAndSensitivities.allergyType.CONTRAST_AGENT",
        defaultMessage: "Kontrasztanyag"
    }
};
const allergyType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AllergyType.DRUG),
    schema_1.Schema.singleChoiceItem(AllergyType.FOOD),
    schema_1.Schema.singleChoiceItem(AllergyType.CONTRAST_AGENT)
]);
const allergyName = schema_1.Schema.string().maxLength(100);
const comment = schema_1.Schema.string().optional();
const allergy = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ allergyType, allergyName, comment }))
    .interpretation({ vocab: "ltx", code: "allergies" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ allergy })
    .interpretation({ vocab: "ltx", code: "allergies_and_sensitivities_form" });
